import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const cleanup = createAction(types.CLEANUP);
export const clearRdcOffset = createAction(types.CLEAR_RDC_OFFSET);
export const decreaseRdcOffset = createAction(types.DECREASE_RDC_OFFSET);
export const increaseRdcOffset = createAction(types.INCREASE_RDC_OFFSET);
export const setCloudType = createAction(types.SET_CLOUD_TYPE);
